export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "jpgcover";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			const vidIcons = document.querySelectorAll(".jpg-cover");
			this.$el.addEventListener("click", (e) => {
				e.preventDefault();
				const iframe = this.$el.querySelector("iframe");
				if (iframe) {
					let src = iframe.getAttribute("data-src");
					this.$el.parentElement.classList.add("video-on");
					if (src.includes("vimeo")) {
						src = src.replace("?", "?autoplay=1&");
					} else if (src.includes("tv.undersco.re")) {
						src = src + "?autoplay=1";
						//&amp;title=0&amp;warningTitle=0&amp;peertubeLink=0&amp;p2p=0
						// <iframe title="2023-03-27 Meet Phase 2 Democracy Machine Fellows Day 1" width="560" height="315" src="https://tv.undersco.re/videos/embed/c6f9d47e-b5fc-4a81-ac54-bbcdd0ea777b?autoplay=1" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups"></iframe>
					} else {
						src = src.replace(
							'feature=oembed"',
							'feature=oembed&autoplay=1"'
						);
					}
					iframe.setAttribute(
						"sandbox",
						"allow-same-origin allow-scripts allow-popups"
					);
					iframe.setAttribute("data-src", null);
					iframe.setAttribute("src", src);
					// iframe.setAttribute(
					// 	"src",
					// 	"https://tv.undersco.re/videos/embed/e0ef4414-0d5b-4270-9c20-38e3d8006fa8?autoplay=1"
					// );

					// replace iframe with '<iframe title="DeLesslin &quot;Roo&quot; George-Warren_Eyebeam_Democracy Machine Fellow Phase 1_2021 + 2022_ Oral History" width="560" height="315" src="https://tv.undersco.re/videos/embed/e0ef4414-0d5b-4270-9c20-38e3d8006fa8?autoplay=1" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups"></iframe>'
					// iframe.outerHTML =
					// 	'<iframe title="DeLesslin &quot;Roo&quot; George-Warren_Eyebeam_Democracy Machine Fellow Phase 1_2021 + 2022_ Oral History" width="560" height="315" src="https://tv.undersco.re/videos/embed/e0ef4414-0d5b-4270-9c20-38e3d8006fa8?autoplay=1" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups"></iframe>';
					// iframe.outerHTML =
					// 	'<iframe title="DeLesslin &quot;Roo&quot; George-Warren_Eyebeam_Democracy Machine Fellow Phase 1_2021 + 2022_ Oral History" width="560" height="315" src="https://tv.undersco.re/videos/embed/e0ef4414-0d5b-4270-9c20-38e3d8006fa8?autoplay=1" frameborder="0" allowfullscreen=""></iframe>';

					// force reload the iframe
					const parent = iframe.parentNode;
					const next = iframe.nextSibling;
					parent.removeChild(iframe);
					parent.insertBefore(iframe, next);
				}
			});
		}
	}
}
